import 'regenerator-runtime/runtime';
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();
